import React from "react";
import { Modal, Table } from "reactstrap";

const DeletedResultHierarchyModal = ({
  isDeleteHierarchyResult,
  toggleDeleteHierarchyResult,
  deletehierarchyListDataResult,
}) => {
  return (
    <Modal
      className="manager-program-settings-dialog modal-lg"
      isOpen={isDeleteHierarchyResult}
      toggle={toggleDeleteHierarchyResult}
      centered
    >
      <div className="manager-program-settings-dialog__header">
        <div className="manager-program-settings-dialog__header-copy">
          <h4 className="manager-program-settings-dialog__title">Removal results</h4>
          <p className="manager-program-settings-dialog__description">
            This event was removed from the following programs.
          </p>
        </div>
        <button
          type="button"
          className="manager-program-settings-dialog__close"
          onClick={toggleDeleteHierarchyResult}
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div className="manager-program-settings-dialog__body">
        <div className="manager-program-settings-dialog__table-shell">
          <Table responsive className="manager-program-settings-dialog__table">
            <thead>
              <tr>
                <th>Program ID</th>
                <th>Program Name</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {deletehierarchyListDataResult.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.result}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="manager-program-settings-dialog__actions">
          <button
            type="button"
            className="manager-program-settings-dialog__action is-primary"
            onClick={toggleDeleteHierarchyResult}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletedResultHierarchyModal;
